// Arrow keys move the history cursor. A key press in a form control keeps
// its usual meaning.

import { HISTORY_KEYS } from '../constants';
import { goLive, goToStart, stepBack, stepForward } from './history';

const ACTIONS: Record<string, () => void> = {
  [HISTORY_KEYS.back]: stepBack,
  [HISTORY_KEYS.forward]: stepForward,
  [HISTORY_KEYS.start]: goToStart,
  [HISTORY_KEYS.live]: goLive,
};

const FORM_CONTROLS = 'input, select, textarea';

/** Call once at startup. */
export const startHistoryKeys = (): void => {
  window.addEventListener('keydown', (event) => {
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.target instanceof Element && event.target.closest(FORM_CONTROLS)) return;
    const action = ACTIONS[event.key];
    if (!action) return;
    event.preventDefault();
    action();
  });
};
